import React, {Component} from "react";
import Dialog from '@mui/material/Dialog';
import {DialogActions} from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import withStyles from "@mui/styles/withStyles";

const styles = {};

class PrivacyPolicy extends Component {

    render() {
        return (
            <Dialog aria-labelledby="Privacy Policy" open={this.props.open} onBackdropClick={this.props.closeHandle}>
                <DialogContent>
                    <h1>PRIVACY POLICY</h1>
                    <p>We take care about all users of VOCA.CLICK
                        and your personal data, so we have prepared Privacy Policy to explain how we
                        process it. This information of processing of personal data is addressed to the
                        clients (users) of the ED-Corporation s.r.o., Business ID: 44678126, Slovak
                        republic limited liability company with registered residence at Sancova 108,
                        83104 Bratislava, Slovak republic and its affiliates and subsidiaries
                        (“ED-Corporation”) which are primarily users (“Users”) of software products of
                        the company (“App”). The company depends on the proper processing of its
                        clients’ personal data. We are processing the data of our clients in accordance
                        with Regulation (EU) 2016/679 of the European Parliament and the Council of
                        27th of April 2016 on the protection of individuals focusing on processing of
                        personal data and on the free movement of such data, which repeals the
                        Directive 95/46/EC (General Regulation on the Protection of Personal Data)
                        (afterwards referred to only as “Regulation”) and the relevant Slovak
                        legislation no. 18/2018 Z. z. on the Protection of Personal Data and on the
                        Amendment to Certain Acts (the “Act”).</p>

                    <p>This document was originally written in
                        English. To the extent any translated version of this document conflicts with
                        the English version, the English version controls.</p>

                    <p>Follow please the text below in
                        acquaintance to the processing of your personal data. The purpose of this
                        document is to provide you with a clear answer to why we are processing your
                        personal data, how we process it, and what your rights according to this
                        process are and provide you with other relevant information about processing
                        your personal data.</p>

                    <h1>Terms related to the process of personal data</h1>

                    <p>Get acquainted with basic terms listed on
                        this document, which can be useful to you for the better understanding of this
                        document.</p>

                    <p>Personal data – any information that
                        relates to the identified and identifiable individual, e. g. name, email
                        address, user ID, IP address, etc.,</p>

                    <p>Affected person / Customer – an
                        individual, to which the personal data are related,</p>

                    <p>Processing of personal data – an operation
                        or set of the operations with personal data, e. g. collecting, organizing,
                        storing, providing to third parties or deleting,</p>

                    <p>Controller / Service provider – an
                        individual or legal person, which determines the purpose and ways related to
                        the processing of your personal data; this competence can be transferred to the
                        intermediary,</p>

                    <p>Intermediary – an individual or legal
                        person, a public authority, an agency or other subject, which processes the
                        personal data for the controller and in his name,</p>

                    <p>Purpose – a reason, why personal data are
                        being processed by the controller,</p>

                    <p>Special categories of personal data –
                        sensitive personal information, which is defined by its specific character, e.
                        g. biometric data to identify the person,</p>

                    <p>Authorized (legitimate) interest – an
                        interest of controller or any other subject that results in the need to process
                        the personal data, if it prevails over the interest of the affected
                        person/customer,</p>

                    <p>Profiling – any automated processing of
                        personal data, which consists of the use of personal data to evaluate certain
                        personal aspects of the affected person/customer,</p>

                    <p>Recipient – individual, legal person,
                        public authority or any other subject, to whom are personal data provided.</p>

                    <h1>The controller of personal data</h1>

                    <p>The controller of your personal data is
                        ED-Corporation s.r.o., Business ID: 44678126, Slovak republic limited liability
                        company with registered residence at Sancova 108, 83104 Bratislava, Slovak
                        republic and its affiliates and subsidiaries (thereinafter in text referred to
                        as “Company”). The Company determines the purpose and ways of the processing of
                        your personal data.</p>

                    <p>Basic information about Company:
                        ED-Corporation s.r.o., Business ID: 44678126, Sancova 108, 83104 Bratislava,
                        Slovak republic. For questions concerning the processing of your personal data
                        by the Company, feel free to contact us via the e-mail address:
                        office@ed-corporation.com or by writing us on our address.</p>

                    <h1>Type of personal data</h1>

                    <p>The Company collects and processes
                        personal data that is necessary to provide you with products and services or,
                        where appropriate, to protect itself and its legitimate interests. The Company
                        processes primarily the next necessary categories of personal data about its
                        customers: a) Identifiers – name, e-mail address, unique identifier (User ID);
                        b) Internet or other similar network activity and other traffic data (IP
                        address, device model, version OS, etc.); c) Geolocation data – country. The
                        listed are also the categories of personal information that Company collected
                        from its customers within the last twelve (12) months.</p>

                    <p>The information Google and/or OpenAI
                        collect(s), and how that information is used, depends on how you use the Google
                        and/or OpenAI services and how you manage your privacy controls.</p>

                    <p>The App collects information about your
                        activity in our services, and also collects the content you create, upload, or
                        receive from others when using our services. The App collects information about
                        the apps, browsers, and devices you use to access third party
                        services e.g. Google, OpenAI, which helps us provide features like automatic
                        product updates and proper software operations.</p>

                    <h1>Source of personal data</h1>

                    <p>The Company collects your personal data in
                        particular from you, especially when accepting the mutual (contractual)
                        agreement about the software use (EULA). Your personal data can be also
                        collected from other subjects – third parties, e. g. Google, OpenAI, however,
                        only on the basis of your personal authorization provided to these subjects in
                        order to grant your data to the Company.</p>

                    <h1>Purposes of processing of personal data</h1>

                    <h2>Concluding and fulfilling the contract</h2>

                    <p>Due to the process of conclusion and
                        fulfillment of the contract Company processes your personal data in order of
                        providing an access to the software of the Company for the user in order of
                        providing the user support and improving the quality of the services provided
                        by the Company necessary to the rightful function through updates and enhancements
                        and providing of new functionalities. For this purpose, Company may follow your
                        interactions with Company, as well as to monitor different areas, in which you
                        are interested in. The collected data can be also used as for the purposes of
                        optimization and improvement of the content of services provided to you by the
                        Company as part of the software and in order to detect potential malfunctions
                        and mistakes (errors). Collected and processed data by Company may be also
                        processed in order to compiling and publishing purposes of general statistical
                        reports to extend and customize of services provided to users, appealing to
                        their preferences. These data do not contain information about the content
                        which could by any way lead to identification of random individual. Data
                        collected by the Company for designed purposes are being processed on the legal
                        basis of the contractual agreement between the Company and end users in form of
                        defined licensing terms and agreements about the use of products and services provided
                        by the Company (EULA).</p>

                    <p>EULA is a contract in accordance with GDPR
                        for the purposes of the determination of legal basis in the operation of
                        processing the personal data. For the needs of above defined purposes Company
                        processes following personal data of the users: a) Registration and
                        authentication via third parties, e. g. Google – e-mail address and other
                        traffic data; b) Direct registration – e-mail address and other traffic data.</p>

                    <h2>Purpose related to direct marketing</h2>

                    <p>The user can purchase additional options,
                        extensions or any other functionality within the terms of a specific
                        application. Various limited offers (so called “premium items”) are being
                        promoted in order to purchase the special edition of the particular element
                        under the conditions of software. These activities represent the form of direct
                        marketing used by Company (in the relation to aforementioned regulations), that
                        is oriented at specific users and address their potential needs. The Company
                        implements these activities only under the conditions of the software itself.
                        The use of these activities in any way does not lead users to the process of
                        purchase, nor does them limit in common use of the software. According to GDPR,
                        the legal basis for processing of your personal data in terms of this form of
                        marketing is to legitimate interest of the Company in accordance with article
                        6, point 1, letter f) and in accordance with section 47 of the GDPR. In terms
                        of the direct marketing’s realization necessaries Company processed the following
                        personal data of users: e-mail address, User ID, IP address.</p>

                    <h1>Providing personal data</h1>

                    <p>We process your personal data to their
                        fullest possible extent internally within the Company. Your personal data are
                        being provided to other subjects only when it’s necessary to achieve the
                        purpose of processing.</p>

                    <p>We do not sell your personal data to other
                        businesses. Your personal data might be in some cases disclosed to and
                        processed by our intermediaries for a business purpose (see below), however
                        personal data are in those cases not shared for monetary or other valuable
                        consideration. In the preceding twelve (12) months, we have not sold personal
                        data. Our policy is that we do not and will not sell personal data of our
                        customers (users).</p>

                    <h2>Intermediaries</h2>

                    <p>The company cooperates in the case of some
                        activities with external subjects, which process personal data under the name
                        of the Company (thereinafter “Intermediaries”). Intermediaries process personal
                        data always on the basis of a contract between the Company and intermediary.
                        The purpose of intermediaries’ services is to collect, store and provide data
                        that are necessary for the basic and distributed operation of provided services
                        by Company within the offered software, as well as providing of the basic
                        infrastructure for the operation of specific functionalities and software
                        components. In the preceding twelve (12) months, we have disclosed the
                        following categories of personal information to our intermediaries for the
                        business purposes: identifiers, internet or other similar network activity,
                        geolocation data.</p>

                    <h2>Public authorities</h2>

                    <p>Your personal data can be provided to
                        public authorities in case of imposition by law or this advance is necessary
                        for the fulfillment of law’s obligations. Public authorities include courts and
                        authorities involved in criminal investigation, etc.</p>

                    <h1>Processing of personal data</h1>

                    <p>Your personal data are being processed on
                        servers within the so-called cloud services, provided through third parties on
                        the basis of a contract between the Company and particular third party. These
                        companies are from the point of view of processing the personal data perceived
                        as an intermediary. Company processes your personal data for as long as it’s
                        necessary for the duration of the EULA’s contractual relations. Company applies
                        the principle of minimalism, which means that after the duration of processing
                        your personal data expires, the personal data will be deleted from databases
                        and information systems of the Company, at the latest 10 years after the
                        termination of a contractual obligation of EULA. Company does not implement in
                        relation to you and your personal data an automatic individualized
                        decision-making including profiling, that could cause legal effects on your
                        person.</p>

                    <h1>Rights related to processing of personal data</h1>

                    <p>You have the following rights in relation to the processing of your personal data:</p>

                    <p><b>a) Access to personal data</b></p>

                    <p>You have the right to request information
                        on whether we process personal data about you as well as to request access to
                        this personal data. You have the right to know why we collect the personal data
                        and how we process it, what kind of personal data we process, which
                        organizations receive the personal data and how the personal data is stored. In
                        case you are California resident, you have the right that we disclose to you a)
                        the categories of personal information we collected about you and the
                        categories of sources from which we collected such information; b) the specific
                        pieces of personal information we collected about you; c) the business or
                        commercial purpose for collecting personal information about you; d) the
                        categories of personal information about you that we shared or disclosed and
                        the categories of third parties with whom we shared or to whom we disclosed
                        such information in the preceding 12 months.</p>

                    <p><b>b) Objection to the processing</b></p>

                    <p>You have right to object to the processing
                        of your personal data in case the processing is being carried due to the
                        legitimate interest of the Company. In case Company will not exhibit that there
                        exist necessary and legitimate reasons for processing, which prevail over your
                        own interests, rights and freedom, or reasons for demonstration, applying or
                        defense of the law requirements, Company will end processing of personal data
                        based on your objection and without undue delay. Where processing is based on
                        consent, you have the right to withdraw your given consent for Company’s use of
                        your personal data at any time. The withdrawal of the approval does not have
                        any effect on the legitimacy of the processing before it was taken back. You
                        always have the right to object to our processing of your personal data for
                        direct marketing purposes.</p>

                    <p><b>c) Correction of personal data</b></p>

                    <p>You have right to demand correction of
                        inaccurate or incomplete personal data, limitation of our processing and
                        completion of incomplete personal data. Company is obligated to correct or
                        complete your personal data without undue delay, always based on available
                        technical options.</p>

                    <p><b>d) Deletion of personal data</b></p>

                    <p>You have the right to demand the deletion
                        of your personal data without undue delay. However, Company may deny your
                        deletion request if retention of your personal data is necessary for the
                        purposes for which the data were collected.</p>

                    <p><b>e) Restriction of processing</b></p>

                    <p>You have the right to request that the
                        processing of your personal data is restricted. There is a risk that we will be
                        unable to provide you with our services during the time the processing is
                        restricted.</p>

                    <p><b>f) The portability of personal data</b></p>

                    <p>Under some circumstances you have the right
                        to gain access to your personal data in a structured, commonly used and
                        machine-readable format (data portability) and have the right to transmit those
                        data to another controller (if it’s technically possible). This right is
                        limited to personal data that you have provided us with, if it is being
                        processed for the purpose of fulfilling a contract with you or based on your
                        consent.</p>

                    <p><b>g) Non-discrimination</b></p>

                    <p>We will not discriminate against you for
                        exercising any of your rights. Unless permitted by the CCPA, we will not a)
                        deny you use of our Services, b) charge you different prices or rates for goods
                        or services, including through granting discounts or other benefits, or
                        imposing penalties, c) provide you a different level or quality of services, d)
                        suggest that you may receive a different price or rate for goods or services or
                        a different level or quality of goods or services.</p>

                    <p><b>h) Other information</b></p>

                    <p>You may be required to submit proof of
                        your identity for these requests to be processed as a verifiable consumer request.
                        We may not be able to comply with your request if we are unable to confirm your
                        identity or to connect the information you submit in your request with personal
                        information in our possession. You may designate an authorized agent to make a
                        request on your behalf subject to proof of identity and authorization.</p>

                    <p>If we determine that the request warrants
                        a fee, we will tell you why we made that decision and provide you with a cost
                        estimate before completing your request.</p>

                    <h1>How to get more information</h1>

                    <p>In case you have questions about the
                        processing of your personal data or you want to know more information, you can
                        contact us by writing us on our address: ED-Corporation s.r.o., Business ID:
                        44678126, Slovak republic limited liability company with registered residence
                        at Sancova 108, 83104 Bratislava, Slovak republic, or by e-mail address:
                        office@ed-corporation.com.</p>

                    <p>Last revised on 15th September 2023</p>
                </DialogContent>
                <DialogActions>
                    <Button type="button" color="primary" variant="contained"
                            onClick={this.props.closeHandle}>Close</Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles(styles)(PrivacyPolicy);
